import { type CountdownBlockProps, type PromoCodeProps } from '@jsmdg/yoshi';
import { type DynamicYieldCampaignData } from '../../../../shared/types/dynamicYieldCampaign';

type CountdownUnits = NonNullable<CountdownBlockProps['countdownUnits']>;

const DESKTOP_PLACEMENT = 'right';
const MOBILE_PLACEMENT = 'bottom';
const MOBILE_SCALE = 0.7;

const isBlockEnabled = (value?: string): boolean => !!value && value !== 'none';

const toNumber = (value?: string): number | undefined => {
    if (value === undefined) {
        return undefined;
    }

    const parsed = Number(value);

    return Number.isFinite(parsed) ? parsed : undefined;
};

const scaleMobileDimension = (value?: number): number | undefined =>
    value ? value * MOBILE_SCALE : undefined;

const getDyCountdown = (
    data: DynamicYieldCampaignData,
    countdownUnits: CountdownUnits,
): { desktop: CountdownBlockProps; mobile: CountdownBlockProps } => {
    const countdown: CountdownBlockProps = {
        enabled: isBlockEnabled(data.Countdown_Enabled),
        endDateTime: data.Countdown_End_DateTime,
        backgroundColor: data.Countdown_Background_Color,
        textColor: data.Countdown_Text_Color,
        opacity: toNumber(data.Countdown_Opacity),
        radius: toNumber(data.Countdown_Radius),
        width: toNumber(data.Countdown_Width),
        height: toNumber(data.Countdown_Height),
        fontSize: toNumber(data.Countdown_Font_Size),
        verticalDistance: toNumber(data.Countdown_Vertical_Distance),
        horizontalDistance: toNumber(data.Countdown_Horizontal_Distance),
        countdownUnits,
    };

    return {
        desktop: {
            ...countdown,
            placement: DESKTOP_PLACEMENT,
        },
        mobile: {
            ...countdown,
            width: scaleMobileDimension(countdown.width),
            height: scaleMobileDimension(countdown.height),
            fontSize: scaleMobileDimension(countdown.fontSize),
            placement: MOBILE_PLACEMENT,
        },
    };
};

const getDyPromo = (
    data: DynamicYieldCampaignData,
    copiedText: string,
): { desktop: PromoCodeProps; mobile: PromoCodeProps } => {
    const promo: PromoCodeProps = {
        enabled: isBlockEnabled(data.Promo_Code_Enabled),
        code: data.Promo_Code,
        copiedText,
        backgroundColor: data.Promo_Background_Color,
        textColor: data.Promo_Text_Color,
        opacity: toNumber(data.Promo_Opacity),
        radius: toNumber(data.Promo_Radius),
        width: toNumber(data.Promo_Width),
        height: toNumber(data.Promo_Height),
        fontSize: toNumber(data.Promo_Font_Size),
        verticalDistance: toNumber(data.Promo_Vertical_Distance),
        horizontalDistance: toNumber(data.Promo_Horizontal_Distance),
    };

    return {
        desktop: {
            ...promo,
            placement: DESKTOP_PLACEMENT,
        },
        mobile: {
            ...promo,
            width: scaleMobileDimension(promo.width),
            height: scaleMobileDimension(promo.height),
            fontSize: scaleMobileDimension(promo.fontSize),
            placement: MOBILE_PLACEMENT,
        },
    };
};

export { getDyCountdown, getDyPromo };
